<template>
    <div class="c-dashboard-quick-datePicker"
        :data-component-name="$options.name"
    >
        <div class="c-dashboard-quick-controls__icon">
            <RangePicker
                v-model="weekrange.str"
                @set-current-date="$emit('set-current-date', $event)"
            />                        
        </div>
        <!-- <div class="c-dashboard-quick-controls__icon c-dashboard-quick-controls__buttons">
            <button class="o-button-circle -client">
                <SvgIcon name="industry" />
            </button>
            <button class="o-button-circle -staff">
                <SvgIcon name="contact" />
            </button>
            <button class="o-button-circle -project"
                @click="$emit('new-project', true)"
            >
                <SvgIcon name="project" />
            </button>
        </div> -->
    </div>
</template>

<script>
    import {getWeeksLimits/*, getDatesBetween, monthStr, dayOfWeekStr /*, dayStr*/} from '@/js/dateUtilities'
    export default {
        name: 'FloatingDateRangePicker',
        components: {
        },
        props: {
			currentDate: {
                type: String,
                default: null
            },
        },
        data(){
            return {
                weekrange: getWeeksLimits(this.currentDate)
            }
        },
        watch:{
            currentDate: function(){
                this.weekrange=getWeeksLimits(this.currentDate)
            }
        },
        mounted(){
        }
    }
</script>
